export const SET_USER = 'SET_USER';
export const USER_CREATED = 'USER_CREATED';
export const USER_FETCHED = 'USER_FETCHED';
export const USERS_FETCHED = 'USERS_FETCHED';
export const USER_DELETED = 'USER_DELETED';
export const LOGOUT = 'LOGOUT';

export const GROUP_FETCHED = 'GROUP_FETCHED';
export const GROUPS_FETCHED = 'GROUPS_FETCHED';
export const GROUP_DELETED = 'GROUP_DELETED';

export const CONTACT_PREFERENCE_FETCHED = 'CONTACT_PREFERENCE_FETCHED';
export const CONTACT_PREFERENCES_FETCHED = 'CONTACT_PREFERENCES_FETCHED';
export const CONTACT_PREFERENCE_DELETED = 'CONTACT_PREFERENCE_DELETED';

export const COMPANY_FETCHED = 'COMPANY_FETCHED';
export const COMPANY_UPDATED = 'COMPANY_UPDATED';
export const COMPANY_DELETED = 'COMPANY_DELETED';

export const INTEGRATIONS_FETCHED = 'INTEGRATIONS_FETCHED';
export const INTEGRATION_FETCHED = 'INTEGRATION_FETCHED';
export const INTEGRATION_DELETED = 'INTEGRATION_DELETED';

export const BEGIN_FETCH_PERMISSIONS = 'BEGIN_FETCH_PERMISSIONS';
export const FETCHED_PERMISSIONS = 'FETCHED_PERMISSIONS';

export const FETCHED_PROJECTS = 'FETCHED_PROJECTS';
export const FETCHED_PROJECT = 'FETCHED_PROJECT';
export const ENABLE_PROJECT_TIMELINE = 'ENABLE_PROJECT_TIMELINE';
export const PROJECT_DELETED = 'PROJECT_DELETED';
export const PROJECT_REPORTS_COUNT_DECREMENT =
  'PROJECT_REPORTS_COUNT_DECREMENT';
export const TAGS_ADDED_TO_PROJECT = 'TAGS_ADDED_TO_PROJECT';
export const PROJECT_SET_PAYMENT_REQUESTS_COUNT =
  'PROJECT_SET_PAYMENT_REQUESTS_COUNT';

export const UPDATE_SETTING_FIELD = 'UPDATE_SETTING_FIELD';

export const UPDATE_RESOURCE_DEFINITIONS = 'UPDATE_RESOURCE_DEFINITIONS';

export const SET_SEARCH_VISIBILITY = 'SET_SEARCH_VISIBILITY';

export const FETCHING_MAP_PROJECTS = 'MAP/FETCHING_MAP_PROJECTS';
export const FETCHED_MAP_PROJECTS = 'MAP/FETCHED_MAP_PROJECTS';
export const FETCHED_MAP_PROJECTS_ERROR = 'MAP/FETCHED_MAP_PROJECTS_ERROR';

export const SELECT_MAP_PROJECT = 'MAP/SELECT_PROJECT';

export const SET_MAP_FILTER = 'MAP/SET_MAP_FILTER';
export const SET_MAP_DATE_FILTER_TYPE = 'MAP/SET_DATE_FILTER_TYPE';
export const SET_MAP_DATE_DATE_RANGE = 'MAP/SET_CUSTOM_DATE_RANGE';
export const SET_MAP_USER_GROUP_FILTER = 'MAP/SET_USER_GROUP_FILTER';
export const SET_MAP_LABEL_FILTER = 'MAP/SET_LABEL_FILTER';

export const FETCHED_MAP_PROJECT_BY_ID = 'MAP/FETCHED_MAP_PROJECT_BY_ID';

export const SET_USER_GEOLOCATION = 'USER_LOCATION/SET_USER_GEOLOCATION';

export const OPEN_REPORT_ASSET_FEED = 'OPEN_REPORT_ASSET_FEED';
export const CLOSE_REPORT_ASSET_FEED = 'CLOSE_REPORT_ASSET_FEED';

export const SET_WIZARD_STEP = 'SET_WIZARD_STEP';
export const SET_WIZARD_SELECTED_ITEMS = 'SET_WIZARD_SELECTED_ITEMS';
export const CLEAR_WIZARD_SELECTED_ITEMS = 'CLEAR_WIZARD_SELECTED_ITEMS';

export const CLEAR_VIEWS = 'CLEAR_VIEWS';
export const PREVIOUS_VIEW = 'PREVIOUS_VIEW';
export const SET_ACTIVE_FILTER_ID = 'SET_ACTIVE_FILTER_ID';
export const SET_CURRENT_TEMPLATE_ID = 'SET_CURRENT_TEMPLATE_ID';
export const SET_VIEW = 'SET_VIEW';
export const SET_TASKLIST_REORDERING_TYPE = 'SET_TASKLIST_REORDERING_TYPE';
export const SET_TEMPLATE_REORDERING_TYPE = 'SET_TEMPLATE_REORDERING_TYPE';
export const SET_EDITING_TASK_ID = 'SET_EDITING_TASK_ID';
export const SET_EDITING_TASK_TEMPLATE_ID = 'SET_EDITING_TASK_TEMPLATE_ID';
